import { useCallback, useRef } from "react";

import { useQueryClient } from "components/QueryClient";

import { useFetch } from "./useFetch";

export function useQuery(queryFactory, more) {
  const client = useQueryClient();
  const clearCacheRef = useRef(() => {});

  const { cached = false, skipAuth = false } = more?.options || {};

  const fetch = useCallback(
    async (v) => {
      const { result, clearCache } = await client.query(
        v,
        queryFactory(),
        !cached,
        { skipAuth }
      );
      clearCacheRef.current = clearCache;

      return result;
    },
    [queryFactory, client, cached, skipAuth]
  );

  const fetchProps = useFetch(more?.options?.overrideFetch || fetch, more);

  return { ...fetchProps, clearCache: clearCacheRef.current || (() => {}) };
}

export default useQuery;
